import {
  CreateWorkAreaMapDocument,
  CreateWorkAreaMapMutation,
  CreateWorkAreaMapMutationVariables,
  GetWorkAreaMapsDocument,
  GetWorkAreasDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateWorkAreaMap = () => {
  const [executeMutation] = useMutation(CreateWorkAreaMapDocument, {
    extractorFn: (data: CreateWorkAreaMapMutation) =>
      data.spaceControlMutations.createSpacecontrolWorkAreaMap,
  })

  const createWorkAreaMap = async (variables: CreateWorkAreaMapMutationVariables) => {
    return executeMutation({
      variables,
      refetchQueries: [GetWorkAreaMapsDocument, GetWorkAreasDocument],
    })
  }

  return {
    createWorkAreaMap,
  }
}
